import { Link } from "react-router-dom";
import { useAppStore } from "../store/useAppStore";
import { DesktopHeaderBar } from "../components/layout/AppShell";
import { Chip } from "../components/ui/Chip";

export function Inbox() {
  const activeSiteId = useAppStore((s) => s.demo.activeSiteId);
  const supportSituations = useAppStore((s) =>
    s.situations.filter((sit) => sit.siteId === activeSiteId && sit.category === "support").sort((a) => (a.status === "open" ? -1 : 1))
  );
  const activities = useAppStore((s) => s.activities.filter((a) => a.siteId === activeSiteId).slice().reverse());
  const units = useAppStore((s) => s.units);

  return (
    <div className="flex flex-1 flex-col gap-5 p-4">
      <DesktopHeaderBar />
      <div>
        <h1 className="font-display text-[24px] font-black tracking-tight text-brand-navy">Inbox</h1>
        <p className="text-[13px] text-muted-foreground">Meaningful communications and events for this site</p>
      </div>

      <section>
        <h2 className="mb-2 font-action text-[12px] font-bold uppercase tracking-wide text-muted-foreground">Tenant support</h2>
        {supportSituations.length === 0 ? (
          <p className="rounded-md border border-dashed border-border p-4 text-[13px] text-muted-foreground">No support requests. Use "Inject MyRise support request" under More → Demo scenarios to see this flow.</p>
        ) : (
          <ul className="flex flex-col gap-2">
            {supportSituations.map((s) => {
              const unit = units.find((u) => u.id === s.unitId);
              return (
                <li key={s.id}>
                  <Link to={`/situations/${s.id}`} className="flex items-center justify-between gap-3 rounded-md border border-border bg-card p-3.5 hover:border-primary">
                    <div>
                      <p className="font-action text-[14px] font-bold text-foreground">{s.title}</p>
                      {unit && <p className="font-mono text-[10.5px] uppercase text-muted-foreground">{unit.unitNumber}</p>}
                    </div>
                    <Chip tone={s.status === "open" ? "attention" : "success"}>{s.status}</Chip>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </section>

      <section>
        <h2 className="mb-2 font-action text-[12px] font-bold uppercase tracking-wide text-muted-foreground">Automation &amp; system</h2>
        <ul className="flex flex-col divide-y divide-border rounded-md border border-border bg-card">
          {activities.map((a) => (
            <li key={a.id} className="flex items-center justify-between gap-3 px-3.5 py-2.5">
              <span className="text-[13px] text-foreground">{a.summary}</span>
              <time className="flex-none font-mono text-[10.5px] text-muted-foreground">{new Date(a.at).toLocaleDateString([], { month: "short", day: "numeric" })}</time>
            </li>
          ))}
          {activities.length === 0 && <li className="px-3.5 py-3 text-[13px] text-muted-foreground">No recent automation activity.</li>}
        </ul>
      </section>
    </div>
  );
}
